<template>
  <b-button size="sm" variant="light" class="ml-2" @click="onClick">
    <span v-if="!allDataChecked(value)">{{ $t('common.text.select_all') }}</span>
    <span v-else>{{ $t('common.text.unselect_all') }}</span>
  </b-button>
</template>


<script>
export default {
  props: {
    value: {
      type: [Array, Object],
      required: true
    }
  },
  data() {
    return {
      inputVal: ''
    }
  },
  watch: {
    value: function(newVal) {
      this.inputVal = newVal
    }
  },
  mounted() {
    this.inputVal = this.value
  },
  methods: {
    onClick() {
      let check = true
      if (this.allDataChecked(this.value)) {
        check = false
      }
      if (this.inputVal) {
        for (const key in this.inputVal) {
          this.inputVal[key] = check
        }
      }
      this.$emit('input', this.inputVal)
      this.$emit('change', this.inputVal)
      this.$forceUpdate()
    }
  }
}
</script>
